export class TermsModel {
  public terms: string;
  public condition: string;
  public mustRegisterToAccess: boolean;
}
